
import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useRoutes } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import routes from './router/config';
import ScrollToTop from './components/base/ScrollToTop';
import './i18n';

function AppRoutes() {
  const element = useRoutes(routes);
  return element;
}

function App() {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  useEffect(() => {
    // Set document direction and language
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.documentElement.lang = i18n.language;
    
    // Add RTL class to body for additional styling
    if (isRTL) {
      document.body.classList.add('rtl');
      document.body.classList.remove('ltr');
    } else {
      document.body.classList.add('ltr');
      document.body.classList.remove('rtl');
    }
  }, [isRTL, i18n.language]);

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollToTop />
      <div className={`min-h-screen overflow-x-hidden max-w-full ${isRTL ? 'font-arabic' : 'font-english'}`}>
        <AppRoutes />
      </div>
    </BrowserRouter>
  );
}

export default App;
